<template>
    <li class="fixture notranslate"
        :class="{'fixture-past': status === 'played', 'fixture-future': status === 'fixture', 'fixture-present': status === 'playing'}">
        <a :href="'/matchday/'+fixture.id" class="clearfix">
			<span v-if="status === 'live'" class="signal"><img src="../../images/icons/signal.svg"></span>
			<span class="club club-home clearfix">
				<span class="club-badge">
					<img v-if="typeof fixture.home_team !== 'undefined'" :src="fixture.home_team.logo_path">
				</span>
				<span class="club-name">
					{{ typeof fixture.home_team !== 'undefined' ? fixture.home_team.club_name : '-' }}
				</span>
			</span>
			<span v-if="score !== null" class="display" dir="ltr">{{ score}}</span>
            <span v-else class="display">{{ fixture.kick_off_time_exists ? fixture.kick_off_time : '__ : __' }}</span>
            <span class="club club-away clearfix">
			<span class="club-badge">
				<img v-if="typeof fixture.away_team !== 'undefined'" :src="fixture.away_team.logo_path">
			</span>
			<span class="club-name">
				{{ typeof fixture.away_team !== 'undefined' ? fixture.away_team.club_name : '-' }}</span>
			<span v-if="typeof fixture.matchTime !== 'undefined'" class="timer">
				{{ typeof fixture.matchTime !== 'undefined' ? fixture.matchTime + "'" : '' }}
			</span>
		</span>
        </a>
    </li>
</template>

<script>
    export default {
        props: ['fixture', 'status'],
        mounted() {
            // we need to resize so that jQuery picks up the size of this rendered element and aligns the score to the
            // middle of the page
            window.dispatchEvent(new Event('resize'));
        },
        computed: {
            score() {
                if (
                    typeof this.fixture.score === 'undefined'
                    || typeof this.fixture.score.total_score_home === 'undefined'
                    || typeof this.fixture.score.total_score_away === 'undefined'
                ) {
                    return null
                }

                return this.fixture.score.total_score_home + ' : ' + this.fixture.score.total_score_away;
            }
        }
    }
</script>
